import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=abe203d4&scoped=true"
import script from "./payment.vue?vue&type=script&lang=ts"
export * from "./payment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe203d4",
  null
  
)

export default component.exports